import React from 'react'
import './ResponsiveMessage.css'
import { NormalButton } from '../components-examples/ReusableCode/EmlyButton'

const MessageBox = (props) => {

  const goBackOption = () => {
    if (props.history && props.history.goBack) {
      props.history.goBack()
    } else if (props.history && props.history.push) {
      props.history.push('/')
    }
  }

  return (
    <div className="responsive-message">
      <div className="responsive-message-content">
        This feature is currently not optimized for mobile devices.
        For the best experience, please access it from a desktop or a device with a larger screen.
      </div>
      <NormalButton onClick={goBackOption} className="em-btn">
        Go Back
      </NormalButton>
    </div>
  )
}

export default MessageBox
